import minWidth from './minWidth';

function getPadding() {
  let leftPadding = 60;
  let topPadding = 100;
  const controlPanel = document.getElementsByClassName('panel-visible')[0];
  leftPadding += controlPanel ? controlPanel.offsetWidth : 0;
  const searchResults = document.getElementById('search-results');
  if (searchResults) {
    if (minWidth()) {
      leftPadding += searchResults.offsetWidth;
    } else {
      topPadding += searchResults.offsetHeight;
    }
  }

  return {
    paddingBottomRight: [50, 100],
    paddingTopLeft: [leftPadding, topPadding],
  };
}

export default getPadding;
